// extracted by mini-css-extract-plugin
export default {"tabButton":"TabButton_tabButton__-6uu8","active":"TabButton_active__7lGBt"};